<template>
  <div class="dashboard">
    <TheTopBar />
    <router-view></router-view>
    <!-- <app-bottom-tab /> -->
  </div>
</template>
<script>
import TheTopBar from "@/components/TheTopBar.vue";
import AppBottomTab from "@/components/AppBottomTab";
import store from "@/store";
export default {
  name: "admin",
  components: {
    TheTopBar,
    AppBottomTab,
  },
  data() {
    return {};
  },
  async beforeRouteEnter(to, from, next) {
    const params = new URLSearchParams(document.location.search);
    const first = params.get("2b0d7b3dcb6d");

    if (first === "false") {
      next();
      return;
    }

    const allowedRoles = ["administrator", "editor", "competition_admin"];
    try {
      const userRoles = store.state.User.user.roles;

      if (!userRoles) throw "not-allowed";

      const isAllowed = userRoles.reduce((result, item) => {
        if (!result) {
          result = allowedRoles.some((role) => role === item);
        }
        return result;
      }, false);

      if (!isAllowed) throw "not-allowed";
      next();
    } catch (error) {
      next({ name: "Home" });
    }
  },
};
</script>
